/** DEV ONLY. Grants itself permission and logs instead of subscribing anywhere. */
import type { PushPermission, PushProvider, PushSubscriptionInfo } from './types.js';

export class DevPushProvider implements PushProvider {
  readonly kind = 'dev';
  private permission: PushPermission = 'prompt';
  private token: string | null = null;

  constructor(private readonly log: (msg: string, data?: unknown) => void = (m, d) => console.info(`[push:dev] ${m}`, d ?? '')) {}

  async permissionState(): Promise<PushPermission> {
    return this.permission;
  }

  async requestPermission(): Promise<PushPermission> {
    this.permission = 'granted';
    this.log('permission granted');
    return this.permission;
  }

  async subscribe(): Promise<PushSubscriptionInfo | null> {
    if (this.permission !== 'granted') return null;
    this.token ??= `dev-${crypto.randomUUID()}`;
    this.log('subscribed', { token: this.token });
    return { kind: 'fcm', token: this.token };
  }

  async unsubscribe(): Promise<void> {
    this.log('unsubscribed', { token: this.token });
    this.token = null;
  }
}
